import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";
import { useParametres } from "./hooks/useParametres";

function App() {
  const { settings } = useParametres();

  useEffect(() => {
    // Mettre à jour le titre de l'onglet avec le nom de l'entreprise
    if (settings?.nom) {
      document.title = settings.nom;
    }

    // Mettre à jour le favicon avec le logo de l'entreprise
    if (settings?.logo_url) {
      const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'icon';
      link.href = settings.logo_url;
      if (!document.querySelector("link[rel*='icon']")) {
        document.head.appendChild(link);
      }
    }
  }, [settings]);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
